class PrintButton {
  constructor(element) {
    this.button = element;
    this.printPage();
  }

  printPage() {
    this.button.addEventListener("click", () => {
      window.print();
    })
  }
}

const printButtons = document.querySelectorAll('[data-print-page-button]');

printButtons.forEach(  (button) => {
  button.PrintButton = new PrintButton(button);
})
